import { Settings } from "../../../Settings";
import ValueCalculator from "../../../util/ValueCalculator";
import NumberValueSkillNode from "../common/NumberValueSkillNode";

export default class MoreMissilesSkillNode extends NumberValueSkillNode {
    /**
     * @param {string} id 
     * @param {string} description 
     * @param {Totals} totals
     * @param {string} iconFileName 
     * @param {BigNum} cost 
     * @param {number} valuePerSkillLevel
     * @param {NumberValue} numberValue
     */
    constructor(id, totals, iconFileName, cost, purchaseListener, valuePerSkillLevel, numberValue) {
        super(id, 'Missiles + ' + Settings.skill.missiles.missilesPerUpgrade, 
            null, totals, iconFileName, cost, purchaseListener, valuePerSkillLevel, numberValue);
    }

    /**
     * @returns {string}
     */
    getDescription() {
        return 'Missiles: ' + ValueCalculator.getMissileCount(this.numberValue);
    }

}